module.exports = __webpack_public_path__ + "img/icon286.b3467186.png";